import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

const initialState = {
    dealer: {},
};

@observer
class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
    }

    render(props) {
        const { appState } = this.props.stores;
        const { darkmode } = appState;
        const { path = '' } = props;
        return (
            <nav class='navbar navbar-expand-lg navbar-themed'>
                <a class='navbar-brand' href='/'>
                    <img src={`/img/logo${darkmode ? '-white' : '-black'}.png`} style='height: 40px;' />
                </a>

                <button class='navbar-toggler' type='button'
                    data-toggle='collapse'
                    data-target='#navbarSupportedContent'
                    aria-controls='navbarSupportedContent'
                    aria-expanded='false'
                    aria-label='Toggle navigation'
                >
                    <span class='navbar-toggler-icon' />
                </button>

                <div class='collapse navbar-collapse' id='navbarSupportedContent'>
                    <ul class='navbar-nav mr-auto' />
                    <div class='my-0 my-lg-0'>
                        <ul class='navbar-nav mr-auto'>

                            <li class={`nav-item ${path.match(/^\/dealers/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/dealers'>
                                    <nobr><i class='fas fa-store-alt' /> Dealers</nobr>
                                </a>
                            </li>

                            <li class={`nav-item ${path.match(/^\/brands/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/brands'>
                                    <nobr><i class='fas fa-copyright' /> Brands</nobr>
                                </a>
                            </li>
                            <li class={`nav-item ${path.match(/^\/categories/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/categories'>
                                    <nobr><i class='fas fa-folder-open' /> Categories</nobr>
                                </a>
                            </li>
                            <li class={`nav-item ${path.match(/^\/products/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/products'>
                                    <nobr><i class='fas fa-box' /> Products</nobr>
                                </a>
                            </li>
                            <li class={`nav-item ${path.match(/^\/productcombos/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/productcombos'>
                                    <nobr><i class='fas fa-boxes' /> Product combos</nobr>
                                </a>
                            </li>

                            <li class={`nav-item ${path.match(/^\/tags/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/tags'>
                                    <nobr><i class='fas fa-tag' /> Tags</nobr>
                                </a>
                            </li>

                            <li class={`nav-item ${path.match(/^\/articles/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/articles'>
                                    <nobr><i class='fas fa-file-alt' /> Articles</nobr>
                                </a>
                            </li>

                        </ul>
                        <ul class='navbar-nav mr-auto'>
                            <li class={`nav-item ${path.match(/^\/consumers/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/consumers'>
                                    <nobr><i class='fas fa-user' /> Consumers</nobr>
                                </a>
                            </li>

                            <li class={`nav-item ${path.match(/^\/rodregs/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/rodregs'>
                                    <nobr><i class='fas fa-signature' /> Rodregs</nobr>
                                </a>
                            </li>

                            <li class={`nav-item ${path.match(/^\/shipments/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/shipments'>
                                    <nobr><i class='fas fa-shipping-fast' /> Shipments</nobr>
                                </a>
                            </li>

                            <li class={`nav-item ${path.match(/^\/maillogs/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/maillogs'>
                                    <nobr><i class='fas fa-envelope' /> Mail logs</nobr>
                                </a>
                            </li>
                            <li class={`nav-item ${path.match(/^\/mailaddresses/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/mailaddresses'>
                                    <nobr><i class='fas fa-at' /> Mail addresses</nobr>
                                </a>
                            </li>

                            <li class={`nav-item ${path.match(/^\/urls/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/urls'>
                                    <nobr><i class='fas fa-link' /> Short urls</nobr>
                                </a>
                            </li>

                            <li class={`nav-item ${path.match(/^\/logout/) ? 'active' : ''}`}>
                                <a class='nav-link' href='/logout'>
                                    <nobr><i class='fas fa-sign-out-alt' /> Logout</nobr>
                                </a>
                            </li>

                            <li class='m'>
                                <button class='btn btn-link'
                                    onClick={() => appState.toggleDarkmode()}
                                >
                                    <i class={`${darkmode ? 'fas text-warning' : 'far'} fa-moon`} />
                                </button>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

export default Navigation;



// WEBPACK FOOTER //
// ./components/navigation/index.js